<template>
  <div class="row mb-2">
    <div class="col-12 col-sm-7">
      <label :for="`drink-plan-${drinkPlan.id}`">{{drinkPlan.name}}</label>
    </div>
    <div class="col-5 col-sm-2">{{drinkPlan.price | currency}}</div>
    <div class="col-7 col-sm-3">
      <div class="input-group">
        <input :id="`drink-plan-${drinkPlan.id}`" type="number" min="0" class="form-control" v-model.number="quantity" @input="onChange" inputmode="numeric">
        <div class="input-group-append">
          <span class="input-group-text">人</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      drinkPlan: Object,
      handleDrinkPlan: Function,
      calculate: Function,
      validatesQuantity: Function,
    },
    data() {
      return {
        quantity: ''
      }
    },
    methods: {
      onChange() {
        const { name, price } = this.drinkPlan
        const quantity = this.quantity
        this.$emit('handleDrinkPlan', { name, price, quantity })
        this.$emit('validatesQuantity')
        this.$emit('calculate')
      }
    }
  }
</script>